<main class="kebab-list-container">
  <section class="kebab-list-item" (click)="onAddToListClick()">
    <span class="icon-text">
      <lucide-icon name="list-plus" size="14"></lucide-icon>
      <span>Add to List</span>
    </span>
  </section>
</main>
